/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Label } from 'reactstrap';
import { MessageFormProps, MessageFormField } from '../types';
import { DestinationCheckboxFields } from './DestinationCheckboxFields';
import { MessageField } from './MessageField';
import { SubjectField } from './SubjectField';
import { UserSelectField } from './UserSelectField';
import { UserMin } from '@g17eco/types/user';

interface ContributorVerifierMessageFormProps extends MessageFormProps {
  contributors: UserMin[];
  verifiers: UserMin[];
}

export const ContributorVerifierMessageForm = (props: ContributorVerifierMessageFormProps) => {
  const { onChange, form, contributors, verifiers } = props;

  return (
    <div className='d-flex flex-column'>
      <Label for='users'>To:</Label>
      <div className='row'>
        <div className='col-6'>
          <UserSelectField label='Contributors' users={contributors} userIds={form.contributorIds} onChange={onChange(MessageFormField.ContributorIds)} />
        </div>
        <div className='col-6'>
          <UserSelectField label='Verifiers' users={verifiers} userIds={form.verifierIds} onChange={onChange(MessageFormField.VerifierIds)} />
        </div>
      </div>
      <SubjectField subject={form.subject} onChange={onChange(MessageFormField.Subject)} />
      <MessageField message={form.message} onChange={onChange(MessageFormField.Message)} />
      <DestinationCheckboxFields sendByEmail={form.sendByEmail} onChange={onChange(MessageFormField.SendByEmail)} />
    </div>
  );
}
